import { createFileRoute } from '@tanstack/react-router';

import { CwfStudyDocumentPage } from '@/pages/blood-report/documents/cwf';

export const Route = createFileRoute(
  '/blood-report/_role-guard/$id/documents/cwf/study/$studyId/$typeId',
)({
  component: CwfStudyDocumentPage,
});
